import type { ReactNode } from "react";
import {
  Card,
  CardHeader,
  Badge,
  Subtitle2,
  Caption1,
  makeStyles,
  tokens,
} from "@fluentui/react-components";

interface SectionCardProps {
  number: number;
  title: string;
  aside?: string;
  description?: string;
  action?: JSX.Element;
  children: ReactNode;
}

const useStyles = makeStyles({
  card: {
    padding: tokens.spacingVerticalL,
    rowGap: tokens.spacingVerticalL,
  },
  badge: {
    marginTop: "2px",
  },
  titleRow: {
    display: "flex",
    alignItems: "baseline",
    gap: tokens.spacingHorizontalS,
    flexWrap: "wrap",
  },
  aside: {
    color: tokens.colorNeutralForeground3,
  },
  desc: {
    color: tokens.colorNeutralForeground3,
  },
});

export default function SectionCard({
  number,
  title,
  aside,
  description,
  action,
  children,
}: SectionCardProps) {
  const styles = useStyles();
  return (
    <Card className={styles.card}>
      <CardHeader
        image={
          <Badge
            className={styles.badge}
            appearance="filled"
            color="brand"
            shape="circular"
            size="large"
          >
            {number}
          </Badge>
        }
        header={
          <div className={styles.titleRow}>
            <Subtitle2>{title}</Subtitle2>
            {aside && <Caption1 className={styles.aside}>{aside}</Caption1>}
          </div>
        }
        description={
          description ? (
            <Caption1 className={styles.desc}>{description}</Caption1>
          ) : undefined
        }
        action={action || undefined}
      />
      {children}
    </Card>
  );
}
